module.exports = __webpack_public_path__ + "img/gov-down.ac88b699.svg";